import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { Subject } from 'rxjs';
import { SeFeThemesLoader } from 'se-fe-themes';

@Component({
  selector: 'app-modal',
  styleUrls: ['./modal.component.scss'],
  templateUrl: './modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ModalComponent implements OnInit, OnDestroy {

  @ViewChild('modalRef', {static: true}) modalRef: TemplateRef<any>;
  @ViewChild('scrollRef', {static: true}) scrollRef: ElementRef; // provides a location to scroll to
  @Output() close = new EventEmitter<boolean>();
  @Output() submit = new EventEmitter<boolean>();
  @Output() addAnother = new EventEmitter<boolean>();
  @Input() header: string;
  @Input() size = 'medium';
  @Input() scroll?: Subject<void>;
  @Input() submitLabel?: string; // Not providing a label will hide the submit button
  @Input() submitting?: boolean;
  @Input() editable: boolean;
  @Input() openAnotherModalCheckbox: boolean;
  @Input() showRibbon: boolean;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private detector: ChangeDetectorRef
  ) { 
    SeFeThemesLoader.load({
      supportedThemes: 'light',
      url: 'https://se-fe-angular-services.ui.sportngin.com'
    });
  }

  ngOnInit(): void {
    this.viewContainerRef.createEmbeddedView(this.modalRef);
    this.detector.detectChanges();
    this.scrollToTop = this.scrollToTop.bind(this);
    if (this.scroll) {
      this.scroll.subscribe(this.scrollToTop);
    }
  }

  ngOnDestroy(): void {
    if (this.scroll) {
      this.scroll.unsubscribe();
    }
  }

  scrollToTop(): void {
    this.scrollRef.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
    this.scrollRef.nativeElement.scrollIntoView();  // this does it for mobile
  }

}
